import { InjectionToken } from '@angular/core';

/**
 * Factory function that creates a named BroadcastChannel.
 */
export const BROADCAST_CHANNEL_FACTORY = new InjectionToken<(name: string) => BroadcastChannel>('BroadcastChannel factory', {
  providedIn: 'root',
  factory: () => (name: string) => new BroadcastChannel(name),
});
